const RML_REST_BUTTON_PREPARE = "RML/RestButton/Prepare";
const RML_REST_BUTTON_SUCCESS = "RML/RestButton/Success";
export { RML_REST_BUTTON_PREPARE, RML_REST_BUTTON_SUCCESS };
